import script from "./VitaInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaInput.vue?vue&type=script&lang=ts&setup=true"

import "./VitaInput.vue?vue&type=style&index=0&id=0eb62fb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb62fb2"]])

export default __exports__